import script from "./QueueGroupedList.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./QueueGroupedList.vue?vue&type=script&setup=true&lang=ts&generic=T"

const __exports__ = script;

export default __exports__